//T.32832 - Servicio para tracking administrativo con geolocalización
import { Injectable } from '@angular/core';
import { Observable, interval, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ICamionTracking, IGarita, IAlertaGeofence } from '../model/tracking-adm.model';

@Injectable({
  providedIn: 'root'
})
export class TrackingAdmService {

  //T.32832 - Configuración de la garita (punto fijo)
  private readonly GARITA: IGarita = {
    nombre: 'Garita Principal',
    latitud: -0.995114,
    longitud: -80.688585,
    radioMetros: 500
  };

  //T.32832 - Almacena el estado anterior de geofence para detectar cambios
  private estadosAnteriores: Map<string, boolean> = new Map();

  constructor() { }

  //T.32832 - Obtiene la configuración de la garita
  getGarita(): IGarita {
    return this.GARITA;
  }

  //T.32832 - Simula obtener camiones activos (usuarios con rol CAMIONES)
  //En producción, esto vendría de un API real
 /* getCamionesActivos(): Observable<ICamionTracking[]> {
    return interval(15000).pipe( // Actualiza cada 15 segundos
      switchMap(() => this.generarDatosCamiones())
    );
  }

  //T.32832 - Obtiene camiones una sola vez (para carga inicial)
  getCamionesInicial(): Observable<ICamionTracking[]> {
    return this.generarDatosCamiones();
  }

  //T.32832 - Genera datos simulados de camiones
  private generarDatosCamiones(): Observable<ICamionTracking[]> {
    const camiones: ICamionTracking[] = [
      {
        id: 'CAM001',
        placa: 'ABC123',
        chofer: 'Juan Pérez',
        cedula: '0912345678',
        latitud: -0.995114 + (Math.random() - 0.5) * 0.01,
        longitud: -80.688585 + (Math.random() - 0.5) * 0.01,
        velocidad: Math.floor(Math.random() * 60),
        timestamp: new Date(),
        enGeofence: false,
        distanciaGarita: 0,
        estado: 'ACTIVO'
      },
      {
        id: 'CAM002',
        placa: 'DEF456',
        chofer: 'María González',
        cedula: '0923456789',
        latitud: -0.995114 + (Math.random() - 0.5) * 0.02,
        longitud: -80.688585 + (Math.random() - 0.5) * 0.02,
        velocidad: Math.floor(Math.random() * 60),
        timestamp: new Date(),
        enGeofence: false,
        distanciaGarita: 0,
        estado: 'ACTIVO'
      },
      {
        id: 'CAM003',
        placa: 'GHI789',
        chofer: 'Carlos Rodríguez',
        cedula: '0934567890',
        latitud: -0.995114 + (Math.random() - 0.5) * 0.015,
        longitud: -80.688585 + (Math.random() - 0.5) * 0.015,
        velocidad: Math.floor(Math.random() * 60),
        timestamp: new Date(),
        enGeofence: false,
        distanciaGarita: 0,
        estado: 'ACTIVO'
      }
    ];

    //T.32832 - Calcula distancia y estado de geofence para cada camión
    camiones.forEach(camion => {
      camion.distanciaGarita = this.calcularDistancia(
        camion.latitud, 
        camion.longitud, 
        this.GARITA.latitud, 
        this.GARITA.longitud
      );
      
      camion.enGeofence = camion.distanciaGarita <= this.GARITA.radioMetros;
    });

    return of(camiones);
  }
  */

  //T.32832 - Calcula distancia entre dos puntos usando fórmula de Haversine
  private calcularDistancia(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371000; // Radio de la Tierra en metros
    const dLat = this.toRadians(lat2 - lat1);
    const dLon = this.toRadians(lon2 - lon1);
    
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(this.toRadians(lat1)) * Math.cos(this.toRadians(lat2)) *
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
    
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  //T.32832 - Convierte grados a radianes
  private toRadians(degrees: number): number {
    return degrees * (Math.PI / 180);
  }

  //T.32832 - Detecta cambios en el estado de geofence
  detectarCambiosGeofence(camiones: ICamionTracking[]): IAlertaGeofence[] {
    const alertas: IAlertaGeofence[] = [];

    camiones.forEach(camion => {
      const estadoAnterior = this.estadosAnteriores.get(camion.id);
      
      if (estadoAnterior !== undefined && estadoAnterior !== camion.enGeofence) {
        alertas.push({
          camionId: camion.id,
          placa: camion.placa,
          timestamp: new Date(),
          tipo: camion.enGeofence ? 'ENTRADA' : 'SALIDA',
          distancia: camion.distanciaGarita
        });
      }

      this.estadosAnteriores.set(camion.id, camion.enGeofence);
    });

    return alertas;
  }
}
